module.exports = "<app-header [ngxInactivity]=\"40\" (ngxInactivityCallback)=\"callback()\" *ngIf=\"currentUser\"></app-header>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main